import { render } from "./ProjectArticleList.vue?vue&type=template&id=4c0a5b79"
import script from "./ProjectArticleList.vue?vue&type=script&lang=js"
export * from "./ProjectArticleList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__